import { useEffect } from "react";
import { Container, Typography, Box, List, ListItem, ListItemText, Grid} from "@mui/material";

const Seccion_Cookies = () => {

    useEffect(() => {
        document.title = "Política de Cookies | Diego Polo Tecnología";

        const metaDescription = document.querySelector("meta[name='description']");
        if (metaDescription) {
            metaDescription.setAttribute(
                "content",
                "Conoce la Política de Cookies de Diego Polo Tecnología: qué son, cómo las usamos y cómo puedes gestionarlas."
            );
        } else {
            const meta = document.createElement("meta");
            meta.name = "description";
            meta.content =
                "Conoce la Política de Cookies de Diego Polo Tecnología: qué son, cómo las usamos y cómo puedes gestionarlas.";
            document.head.appendChild(meta);
        }

        // JSON-LD para SEO
        const script = document.createElement("script");
        script.type = "application/ld+json";
        script.innerHTML = JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebPage",
            name: "Política de Cookies | Diego Polo Tecnología",
            description:
                "Conoce la Política de Cookies de Diego Polo Tecnología: qué son, cómo las usamos y cómo puedes gestionarlas.",
            publisher: {
                "@type": "Organization",
                name: "Diego Polo Tecnología",
            },
        });
        document.head.appendChild(script);

        return () => {
            document.head.removeChild(script);
        };
    }, []);

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Container maxWidth="md" sx={{ py: 8, maxWidth:1400, px:3 }}>
                <Typography variant="h3" gutterBottom>
                    Política de Cookies
                </Typography>

                <Typography paragraph>
                    En <strong>Diego Polo Tecnología</strong> utilizamos cookies para mejorar la experiencia de
                    navegación, analizar el tráfico y personalizar el contenido. Al continuar en nuestro sitio,
                    aceptas el uso de cookies según lo indicado en esta política.
                </Typography>

                <Box my={4}>
                    <Typography variant="h5" gutterBottom>
                        1. ¿Qué son las cookies?
                    </Typography>
                    <Typography paragraph>
                        Las cookies son pequeños archivos de texto que se almacenan en tu navegador cuando visitas
                        un sitio web. Sirven para recordar tus preferencias y mejorar tu experiencia en futuras
                        visitas.
                    </Typography>
                </Box>

                <Box my={4}>
                    <Typography variant="h5" gutterBottom>
                        2. Tipos de cookies que utilizamos
                    </Typography>
                    <List>
                        <ListItem>
                            <ListItemText
                                primary="Cookies esenciales"
                                secondary="Necesarias para el funcionamiento básico del sitio web."
                            />
                        </ListItem>
                        <ListItem>
                            <ListItemText
                                primary="Cookies de rendimiento"
                                secondary="Nos permiten analizar el uso del sitio para mejorarlo."
                            />
                        </ListItem>
                        <ListItem>
                            <ListItemText
                                primary="Cookies de funcionalidad"
                                secondary="Recuerdan tus preferencias y configuraciones."
                            />
                        </ListItem>
                        <ListItem>
                            <ListItemText
                                primary="Cookies de terceros"
                                secondary="Proporcionadas por servicios externos como Google Analytics."
                            />
                        </ListItem>
                    </List>
                </Box>

                <Box my={4}>
                    <Typography variant="h5" gutterBottom>
                        3. ¿Cómo gestionar las cookies?
                    </Typography>
                    <Typography paragraph>
                        Puedes configurar tu navegador para aceptar, rechazar o eliminar cookies en cualquier
                        momento. Ten en cuenta que deshabilitar ciertas cookies puede afectar el correcto
                        funcionamiento de nuestro sitio.
                    </Typography>
                </Box>

                <Box my={4}>
                    <Typography variant="h5" gutterBottom>
                        4. Cambios en la política
                    </Typography>
                    <Typography paragraph>
                        Nos reservamos el derecho a modificar esta política de cookies en cualquier momento.
                        Cualquier cambio será publicado en esta misma página con la fecha de actualización.
                    </Typography>
                </Box>

                <Box my={4}>
                    <Typography variant="h5" gutterBottom>
                        5. Contacto
                    </Typography>
                    <Typography paragraph>
                        Si tienes dudas sobre nuestra política de cookies, puedes escribirnos a{" "}
                        <a href="mailto:contacto@diegopolotecnologia.com">
                            contacto@diegopolotecnologia.com
                        </a>.
                    </Typography>
                </Box>
            </Container>
        </Grid>
    )

}
export default Seccion_Cookies